(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Filter products by model parameter
  const modelParam = url.searchParams.get('model');
  if (modelParam) {
    document.addEventListener('DOMContentLoaded', () => {
      const productItems = document.querySelectorAll('.product-grid__item[data-product-model]');
      let visibleCount = 0;

      for (const item of productItems) {
        const productModel = item.getAttribute('data-product-model');
        if (productModel && productModel.toLowerCase() === modelParam.toLowerCase()) {
          item.style.display = '';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      }

      // Update product count if element exists
      const productCountElement = document.querySelector('[data-testid="products-count"]');
      if (productCountElement && visibleCount > 0) {
        const countText = visibleCount === 1 ? '1 product' : `${visibleCount} products`;
        productCountElement.textContent = countText;
      }

      // Show message if no products match
      if (visibleCount === 0) {
        const grid = document.querySelector('.product-grid');
        if (grid) {
          const noResults = document.createElement('div');
          noResults.className = 'collection-no-results';
          noResults.style.padding = 'var(--padding-xl)';
          noResults.style.textAlign = 'center';
          noResults.innerHTML = `<p>No products found for model "${modelParam}".</p>`;
          grid.parentNode.insertBefore(noResults, grid.nextSibling);
        }
      }
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
